import React, { useEffect, useMemo, useState } from "react";
import { Button, Form, Input } from "antd";
import { Link } from "react-router-dom";
import { useSendEmailResetPasswordByEmail } from "../../../../../services/auth/mutations";

interface FormResetPasswordProps {
  isSubmitted: boolean,
  setIsSubmitted: (isSubmitted: boolean) => void
  email: string | null;
  setEmail: (email: string | null) => void
}

const FormResetPassword = (props: FormResetPasswordProps) => {
  const [form] = Form.useForm();
  const { isSubmitted, email, setIsSubmitted, setEmail } = props;

  const {
    data: response,
    fetching,
    execute: sendEmailResetPassword
  } = useSendEmailResetPasswordByEmail();

  const [error, setError] = useState<boolean>(false);
  const [focusedFields, setFocusedFields] = useState<Record<string, boolean>>({
    email: false
  });

  const emailValue = Form.useWatch('email', form);
  const showEmailLabel = useMemo(
    () => focusedFields.email || !!emailValue,
    [focusedFields.email, emailValue]
  );

  useEffect(() => {
    if (response) {
      setError(false);
      setIsSubmitted(true);
    }
    else if (response === false) setError(true);
  }, [response])

  const onFinish = (values: any) => {
    setError(false);
    sendEmailResetPassword({ email: values.email });
    setEmail(values.email)
  };

  const content = (
    !isSubmitted ?
      <>
        <Form.Item
          name="email"
          className="form-item"
          rules={[
            {
              type: 'email',
              required: true,
              message: "Please input your email!",
            },
          ]}>
          <div className={`form-item__wrapper ${showEmailLabel ? 'form-item__wrapper--with-label' : ''}`}>
            {showEmailLabel && (
              <label className="floating-label" htmlFor="reset-password-email">
                Email address
              </label>
            )}
            <Input
              id="reset-password-email"
              type="email"
              placeholder="Email address"
              className="form-item__input"
              onChange={() => setError(false)}
              onFocus={() =>
                setFocusedFields((prev) => ({
                  ...prev,
                  email: true
                }))
              }
              onBlur={() =>
                setFocusedFields((prev) => ({
                  ...prev,
                  email: false
                }))
              }
            />
          </div>
        </Form.Item>

        {error &&
          <p className="message-error">
            {`*We couldn’t find an account with this email address`}
          </p>
        }

        <Form.Item>
          <Button
            className="button button-primary button-txt-big"
            loading={fetching}
            htmlType="submit">
            Send password reset email
          </Button>
        </Form.Item>
      </>
      :
      <>
        <div
          className="body-regular link resend"
          rel="noopener noreferrer"
        >
          Didn&apos;t receive the email?{" "}
          <span className="body-regular-bold" onClick={() => onFinish({ email })}>Resend it</span>
        </div>
      </>
  )

  return (
    <Form
      form={form}
      name="basic"
      onFinish={onFinish}
      className="form"
      autoComplete="off"
    >
      {content}
      <div className="back">
        <Link className="body-regular link" to="/login">
          <span className="body-regular-bold">{`<-- Back to login`}</span>
        </Link>
      </div>
    </Form>
  );
};
export default FormResetPassword;
